import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCareerDna } from "@/hooks/useCareerDna";
import { resolveCareerIds } from "@/lib/certifications";
import { useLearnerCountry } from "@/hooks/useLearnerCountry";
import { COUNTRY_LABEL } from "@/lib/learnerCountry";
import { CountryRoadmap } from "./CountryRoadmap";

/** Next Steps: the same country roadmap shown on the top match's career page. */
export default function NextStepRoadmap() {
  const { data: dna } = useCareerDna();
  const { country } = useLearnerCountry();
  const [ciId, setCiId] = useState<string | null>(null);
  useEffect(() => {
    if (dna?.matches?.length) resolveCareerIds(dna.matches.slice(0, 1)).then((ids) => setCiId(ids[0] ?? null)).catch(() => setCiId(null));
  }, [dna]);
  if (!ciId) return null;
  const title = (dna?.matches?.[0] as any)?.title ?? (dna?.matches?.[0] as any)?.name ?? "your top match";
  return (
    <section aria-labelledby="ns-roadmap" className="space-y-3">
      <h2 id="ns-roadmap" className="font-display text-xl font-bold text-foreground">Your roadmap in {COUNTRY_LABEL[country]}</h2>
      <p className="text-sm text-muted-foreground">
        The route to {title}, step by step. <Link to={`/careers/${ciId}`} className="text-primary hover:underline">Open the career page</Link>
      </p>
      <CountryRoadmap ciId={ciId} country={country} />
    </section>
  );
}
